
import React from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../components/comitesMain.css";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";

import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';
import isologo from '../assets/isologo-2026.png';
import heroImg from "../assets/imagen.jpg";

export default function ComitesMain() {
  const { settings } = useSiteSettings();
  const bannerSrc = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;
  return (
    <>
      <NavbarFacach />

      <div className="comites-page">
        {/* Banner */}
        <div className="banner-wrapper">
          <Image src={bannerSrc} alt="..." fluid className="banner-image" />
          <div className="banner-overlay">
            <h1 className="banner-title">COMITÉS INSTITUCIONALES</h1>
            <p className="banner-description">
              Accede a los comités establecidos por ley y consulta su información básica.
            </p>
          </div>
        </div>

        {/* Sección Por Ley */}
        <section className="cards-section-light py-5" aria-label="Comités Por Ley">
          <Container>
            <Row className="g-4 align-items-stretch">
              {/* Marco general (izquierda) */}
              <Col md={7}>
                <Card className="marco-card h-100 shadow-sm">
                  <Card.Body className="p-4 p-sm-5">
                    <h2 className="marco-title mb-3" id="marco-general-title">
                      NUESTROS COMITÉS
                    </h2>
                    <p className="text-muted mb-3">
                      Lineamientos básicos para la conformación y funcionamiento de los comités
                      establecidos por normativa cooperativa.
                    </p>

                    <div className="marco-block">
                      <h5 className="marco-subtitle">Finalidad</h5>
                      <p>
                        Fortalecer la participación, formación y equidad dentro de la organización,
                        promoviendo el cumplimiento de objetivos sociales y educativos.
                      </p>
                    </div>

                    <div className="marco-block">
                      <h5 className="marco-subtitle">Composición</h5>
                      <p>
                        Integrado por miembros designados de acuerdo con los estatutos y la normativa
                        interna. Se privilegia la representatividad y la rotación periódica.
                      </p>
                    </div>

                    <div className="marco-block">
                      <h5 className="marco-subtitle">Funciones principales</h5>
                      <ul className="list">
                        <li>Planificar y ejecutar actividades acorde a su objetivo (juventud, educación, género).</li>
                        <li>Asesorar a la dirección en iniciativas y proyectos del área.</li>
                        <li>Velar por el cumplimiento de la normativa y buenas prácticas cooperativas.</li>
                        <li>Presentar informes de avance y resultados.</li>
                      </ul>
                    </div>

                    <div className="marco-block">
                      <h5 className="marco-subtitle">Periodo y renovación</h5>
                      <p>
                        La duración y mecanismos de renovación se definen en los estatutos y políticas
                        internas, garantizando continuidad y relevo ordenado.
                      </p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={5}>
              
                <Card className="card-ley upgraded h-100 shadow-sm">
                   <div style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop:"10px"
                      
                    }}>
                      <img
                        src={isologo}
                        alt="FACACH"
                        style={{
                          width: 200,
                          height: 200,
                          objectFit: "contain",
                          filter: "drop-shadow(0 4px 12px rgba(37,42,88,0.2))",
                        }}
                      />
                    </div>
                  <span className="card-ley-border" aria-hidden="true" />
                  <Card.Body className="text-center p-4 p-sm-5">
                    {/* <div className="icon mb-3" aria-hidden="true">⚖️</div> */}
                    <Card.Title className="mb-2 ley-title">
                      Comités por Ley
                    </Card.Title>
                    <Card.Text className="text-muted ley-subtitle">
                      Seleccione el comité para ver funciones, requisitos y documentos.
                    </Card.Text>
                    <div
                      className="committee-grid mt-4"
                      role="navigation"
                      aria-label="Enlaces a comités por ley"
                    >
                      <Link
                        to="/comiteJuventud"
                        className="committee-link"
                        aria-label="Ver Comité de Juventud"
                      >
                        {/* <span className="emoji" aria-hidden="true">🧑‍🎓</span> */}
                        <span className="text">Comité de Juventud</span>
                      </Link>

                      <Link
                        to="/comiteEducacion"
                        className="committee-link"
                        aria-label="Ver Comité de Educación"
                      >
                        {/* <span className="emoji" aria-hidden="true">📚</span> */}
                        <span className="text">Comité de Educación</span>
                      </Link>

                      <Link
                        to="/comiteGenero"
                        className="committee-link"
                        aria-label="Ver Comité de Género"
                      >
                        {/* <span className="emoji" aria-hidden="true">⚧</span> */}
                        <span className="text">Comité de Género</span>
                      </Link>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </div>

      <FooterFacach />
    </>
  );
}